import $ from "jquery";

const menuOpenClass = "is-open";
const menuTriggerClass = ".js-toggle-branchnav";

function toggleBranchNav() {
  $(".branchnav .wp-menu").stop().slideToggle(250);
  $(".branchnav").toggleClass(menuOpenClass);
}

$(menuTriggerClass).on("click", toggleBranchNav);
